import { UsersList } from '../user-management/UsersList';
import { RolesPermissions } from '../user-management/RolesPermissions';
import { UserInviteDialog } from '../user-management/UserInviteDialog';

import { useUsers, useRoles } from '@/hooks/react-query/useUsers';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useState } from 'react';

export function UserManagement() {
  // React Query hooks
  const { data: users = [], refetch: refetchUsers } = useUsers();

  const { data: roles = [] } = useRoles();

  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);

  const handleUserUpdated = () => {
    refetchUsers();
  };

  return (
    <>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold">User Management</h1>
            <p className="text-muted-foreground mt-1">
              Manage user accounts, roles, and permissions
            </p>
          </div>
          <Button onClick={() => setInviteDialogOpen(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Invite User
          </Button>
        </div>

        <Tabs defaultValue="users" className="space-y-4">
          <TabsList>
            <TabsTrigger value="users">Users</TabsTrigger>
            <TabsTrigger value="roles">Roles & Permissions</TabsTrigger>
          </TabsList>
          <TabsContent value="users">
            <UsersList
              users={users}
              roles={roles}
              onUserUpdated={handleUserUpdated}
            />
          </TabsContent>
          <TabsContent value="roles">
            <RolesPermissions roles={roles} />
          </TabsContent>
        </Tabs>
      </div>

      <UserInviteDialog
        open={inviteDialogOpen}
        onOpenChange={setInviteDialogOpen}
        roles={roles}
        onUserInvited={handleUserUpdated}
      />
    </>
  );
}
